import React from 'react';
import HeaderSection from "../headerSection/HeaderSection";
import {useForm} from 'react-hook-form';
import {ErrorMessage} from '@hookform/error-message';
import './ShrineFoodStyle.scss'
import leftBorder from '../../assets/images/topborder.svg';
import rightBorder from '../../assets/images/topborder.svg';

function ShrineFood() {
    const {register, formState: {errors}, watch, handleSubmit} = useForm();
    const onSubmit = data => {
        console.log(data);
    };
    const behalf = watch("behalf");
    return (
        <div className='ShrineFood-container'>
            <HeaderSection></HeaderSection>
            <div className='ShrineFood-section '>
                <div className='form-container'>
                    <form onSubmit={handleSubmit(onSubmit)} className='ShrineFood-form'>
                        <div className='border-form'>
                            <img src={rightBorder} className="right-border" alt=""/>
                        </div>

                        <div className="mb-3 d-column">
                            <label className="form-label">نام :</label>
                            <input className='form-control' type="text" placeholder="نام" {...register("fristName", {
                                required: "این فیلد الزامی میبشد",
                                maxLength: 30,
                                pattern: {
                                    value: /^[\u0600-\u06FF\s]+$/,
                                    message: "لطفا نام فارسی خود را وارد نمایید",
                                },
                            })} />
                            <ErrorMessage errors={errors}
                                          name="fristName"
                                          render={({message}) => <span className='erore-massage'>{message}</span>}
                            />
                        </div>

                        <div className="mb-3 d-column">
                            <label className="form-label">نام خانوادگی :</label>
                            <input className='form-control' type="text"
                                   placeholder="نام خانوادگی" {...register("lastName", {
                                required: "این فیلد الزامی میبشد",
                                maxLength: 30,
                                pattern: {
                                    value: /^[\u0600-\u06FF\s]+$/,
                                    message: "لطفا نام فارسی خود را وارد نمایید",
                                },
                            })} />
                            <ErrorMessage errors={errors}
                                          name="lastName"
                                          render={({message}) => <span className='erore-massage'>{message}</span>}
                            />

                        </div>
                        <div className="mb-3 d-column">
                            <label className="form-label">کد ملی :</label>
                            <input className='form-control' type="number"
                                   placeholder="کد ملی" {...register("nationalId", {
                                required: "این فیلد الزامی میبشد",
                                maxLength: 11,
                                pattern: {
                                    value: /^[0-9]+$/,
                                    message: 'فرمت کد ملی شما اشتباه میباشد',
                                },
                            })} />
                            <ErrorMessage errors={errors}
                                          name="phoneNumber"
                                          render={({message}) => <span className='erore-massage'>{message}</span>}
                            />
                        </div>

                        <div className="mb-3 d-column">
                            <label className="form-label">شماره موبایل :</label>
                            <input className='form-control' type="number"
                                   placeholder="شماره موبایل" {...register("phoneNumber", {
                                required: "این فیلد الزامی میبشد",
                                maxLength: 11,
                                pattern: {
                                    value: /^[0][9][0-9][0-9]{8,8}$/,
                                    message: 'فرمت شماره موبایل  باید ****09 باشد.',
                                },
                            })} />
                            <ErrorMessage errors={errors}
                                          name="phoneNumber"
                                          render={({message}) => <span className='erore-massage'>{message}</span>}
                            />
                        </div>
                        <input type="submit" value='ارسال' className='submit'/>

                        <div className='border-form'>
                            <img src={leftBorder} className="left-border" alt=""/>
                        </div>

                    </form>
                </div>

                <div className='shrinefood-information'>
                    <h5>فرم ثبت نام غذای حضرتی</h5>
                    <br/>
                    <p>برای ثبت نام جهت دریافت غذای حضرتی حرم امام زاده جعفر لطفا اطلاعات خود را در فرم وارد نمایید.</p>
                    <p>هر شخص با هر کد ملی میتواند فقط یکبار میتواند ثبت نام به عمل بیاورد</p>
                    <h5>نکته:</h5>
                    <p>ثبت نام شما به این منظور است که در صورتی که ظرفیتی وجود داشته باشد نتیجه این ثبت نام از طریق
                        پیامک به شما اطلاع رسانی میگردد</p>
                    <p>و شما میتوانید با مراجعه به اشپزخانه حرم غذای خود را دریافت نمایید.</p>

                    <div className='hadis-section'>
                        <img src={rightBorder} className="hadis-border" alt=""/>
                        <div className='hadis-box'>
                            <h6>حضرت امام رضا (ع) فرمود:</h6>
                            <span>رحمت خدا بر بنده ای که امر ما را زنده کند، دانش های ما را فرا گیرد و به مردم بیاموزد. اگر مردم زیبایی های سخنان ما را می دانستند از ما پیروی می کردند.</span>
                            <span style={{alignSelf: 'end'}}>معانی الأخبار، ص 180، ح 1</span>
                        </div>
                        <img src={leftBorder} className="left-border hadis-border" alt=""/>
                    </div>

                </div>
            </div>
        </div>
    )
}

export default ShrineFood;

